// Minimal js-cookie replacement covering what beebee code actually uses:
// get/set/remove with { expires (days, fractions ok), path, domain, secure, sameSite }.
//
// Value encoding replicates js-cookie's writer: encodeURIComponent, then restore
// the characters js-cookie leaves raw (#$&+/:<=>?@[]^`{|}...). Existing cookies
// (session token, beebee_domain URL read by other beebeeboard properties) keep
// the exact same wire format.
//
// Exported as a mutable object so tests can stub single methods.
const cookies = {
  get(name) {
    const row = document.cookie.split('; ').find(entry => entry.startsWith(`${name}=`));
    if (!row) {
      return undefined;
    }
    return decodeURIComponent(row.slice(name.length + 1));
  },
  set(name, value, options = {}) {
    const encoded = encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    let cookie = `${name}=${encoded}; path=${options.path || '/'}`;
    if (options.expires !== undefined) {
      cookie += `; expires=${new Date(Date.now() + options.expires * 864e5).toUTCString()}`;
    }
    if (options.domain) {
      cookie += `; domain=${options.domain}`;
    }
    if (options.sameSite) {
      cookie += `; SameSite=${options.sameSite}`;
    }
    if (options.secure) {
      cookie += '; Secure';
    }
    document.cookie = cookie;
  },
  remove(name, options = {}) {
    this.set(name, '', {
      ...options,
      expires: -1
    });
  }
};

export { cookies };
//# sourceMappingURL=cookie.js.map
